import { render, staticRenderFns } from "./ChipFilters.vue?vue&type=template&id=7ad0fab3&"
import script from "./ChipFilters.vue?vue&type=script&lang=js&"
export * from "./ChipFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports